// --- COURSES CONFIGURATION ---
export const AI_LAB_COURSES = [
  { id: "ai-robotics", label: "AI & Robotics", icon: "🤖", bg: "#eff6ff", border: "#bfdbfe", text: "#1d4ed8" },
  { id: "coding", label: "Coding", icon: "💻", bg: "#faf5ff", border: "#e9d5ff", text: "#7e22ce" },
  { id: "design", label: "Design", icon: "🎨", bg: "#fffbeb", border: "#fef3c7", text: "#b45309" },
  { id: "video-editing", label: "Video Editing", icon: "🎬", bg: "#ecfdf5", border: "#a7f3d0", text: "#047857" },
  { id: "aerodynamics", label: "Aerodynamics", icon: "✈️", bg: "#f0f9ff", border: "#bae6fd", text: "#0369a1" },
  { id: "sketching", label: "Sketching & Drawing", icon: "✏️", bg: "#fff1f2", border: "#fecdd3", text: "#be123c" },
  { id: "3d-modelling", label: "3D Modelling & Printing", icon: "🖨️", bg: "#f5f3ff", border: "#ddd6fe", text: "#6d28d9" },
  { id: "smart-money", label: "Smart Money Skills for Kids", icon: "💰", bg: "#f0fdf4", border: "#bbf7d0", text: "#15803d" },
];

// --- AVAILABLE GRADE LEVELS ---
export const GRADE_OPTIONS = Array.from({ length: 12 }, (_, i) => ({
  value: `Class ${i + 1}`,
  label: `Class ${i + 1}`,
}));

// --- GRADE-BASED PRICING TIERS ---
export const PRICING_TIERS = [
  { minGrade: 1, maxGrade: 4, price: 1500, label: "Class 1–4" },
  { minGrade: 5, maxGrade: 8, price: 2500, label: "Class 5–8" },
  { minGrade: 9, maxGrade: 12, price: 4500, label: "Class 9–12" },
];

// --- AVAILABLE WEEKDAYS ---
export const AVAILABLE_DAYS = [
  "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"
];

// --- TIME SLOTS ---
export const TIME_SLOTS = [
  { id: "slot-9-10", label: "09:00 AM – 10:00 AM" },
  { id: "slot-10-11", label: "10:00 AM – 11:00 AM" },
  { id: "slot-11-12", label: "11:00 AM – 12:00 PM" },
  { id: "slot-14-15", label: "02:00 PM – 03:00 PM" },
  { id: "slot-15-16", label: "03:00 PM – 04:05 PM" },
  { id: "slot-16-17", label: "04:00 PM – 05:00 PM" },
  { id: "slot-17-18", label: "05:00 PM – 06:00 PM" },
  { id: "slot-18-19", label: "06:00 PM – 07:00 PM" },
];


export const MAX_CHILDREN = 5;

// --- DYNAMIC PRICING CALCULATION HELPERS ---
export const getPriceForGrade = (gradeString) => {
  if (!gradeString) return 0;
  const gradeNum = parseInt(gradeString.replace("Class ", ""), 10);
  const tier = PRICING_TIERS.find(t => gradeNum >= t.minGrade && gradeNum <= t.maxGrade);
  return tier ? tier.price : 0;
};

export const OFFERS_ENABLED = true;
export const MULTI_COURSE_DISCOUNT = 200;
export const SIBLING_DISCOUNT = 500;

export const calculateChildCost = (child) => {
  const basePrice = getPriceForGrade(child.grade);
  const courseCount = child.interests?.length || 0;
  let cost = basePrice * courseCount;
  if (OFFERS_ENABLED && courseCount >= 2) {
    cost -= (courseCount - 1) * MULTI_COURSE_DISCOUNT;
  }
  return cost;
};

export const calculateEnrolmentDetails = (childrenData) => {
  let totalCourseAmount = 0;
  let childDiscountTotal = 0;

  childrenData.forEach((child) => {
    const basePrice = getPriceForGrade(child.grade);
    const courseCount = child.interests?.length || 0;
    totalCourseAmount += basePrice * courseCount;

    if (OFFERS_ENABLED && courseCount >= 2) {
      childDiscountTotal += (courseCount - 1) * MULTI_COURSE_DISCOUNT;
    }
  });

  let siblingDiscount = 0;
  if (OFFERS_ENABLED && childrenData.length >= 2) {
    siblingDiscount = (childrenData.length - 1) * SIBLING_DISCOUNT;
  }

  const registrationFee = 0;
  const totalDiscount = childDiscountTotal + siblingDiscount;
  const finalTotal = Math.max(0, totalCourseAmount - totalDiscount + registrationFee);

  return {
    totalCourseAmount,
    childDiscounts: childDiscountTotal,
    siblingDiscount,
    registrationFee,
    totalDiscount,
    finalTotal,
  };
};
